<template>
  <div class="step-progress">
    <div class="d-flex justify-content-between">
      <template v-for="(step, index) in steps">
        <div :key="index" class="step">
          <span
            class="circle"
            :class="{active: value>=index+1}"
          >
            <template v-if="value > index+1">
              <font-awesome-icon :icon="faCheck"/>
            </template>
            <template v-else>
              {{index + 1}}
            </template>
          </span>
          <br/>
          <span class="label">{{step}}</span>
        </div>
      </template>
    </div>
    <div class="wrapper-after"></div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'StepProgress',
  components: {
    FontAwesomeIcon,
  },
  props: {
    steps: Array,
    value: {
      type: Number,
      default: 0
    },
  },
  setup() {
    return {
      faCheck,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

.step-progress{
  width: 100%;
  position: relative;

  .step {
    z-index: 2;
    position: relative;
    height: 100%;

    .circle {
      align-items: center;
      border-radius: 50%;
      display: inline-flex;
      font-size: 16px;
      font-weight: bold;
      justify-content: center;
      height: 38px;
      width: 38px;
      border: 3px solid $alizarinCrimson;
      color: $alizarinCrimson;
      background-color: $ghostWhite;
    }

    .active {
      color: $white;
      background-color: $alizarinCrimson;
    }

    .label {
      font-size: 14px;
    }
  }

  .wrapper-after {
    position: absolute;
    height: 4px;
    top: 32%;
    text-align: center;
    transform: translateY(-50%);
    width: 99%;
    background-color: $alizarinCrimson;
  }
}
</style>
